import $ from 'jquery';

// for header dropdown elements specifically
$('.navbar-nav .dropdown-toggle').on('click', function(e){
  window.location.href = $(e.currentTarget).attr('href');
});